<template lang="pug">
  SspLayout(area="core")
    template(slot="actions")
      router-link.btn.btn-primary(:to="{name: 'createMetadataSchema'}") New Metadata Schema

    DataGrid(ref="grid" :fetch="fetchData" @error="$emit('error', $event)" url-page-param="page")
      tr(slot="thead")
        th Id
        th Name
        th Default
        th
      tr(v-for="s in schemas")
        td {{s.id}}
        td {{s.name}}
        td
          i.fa.fa-2x(@click="setAsDefaultSchema(s)" :class="s.isDefault ? 'fa-check-square-o' : 'fa-square-o'")
        td.actions
          router-link.btn-view(:to="{name: 'viewMetadataSchema', params: {id: s.id}}" title="View schema") View
          a.btn-trash(@click="deleteMetadataSchema(s.name)" title="Delete schema")

</template>

<script>
import Core from '@/service/apis/Core'
import DataGrid from '@/components/ssp/DataGrid'

export default {
  data: () => ({
    schemas: null,
    errorMsg: null
  }),
  methods: {
    fetchData(page) {
      const req = page.maxOffsetRequest()
      return Core.getMetadataSchemas(req)
        .then((resp) => {
          this.schemas = resp.data.schema
          return resp.data.totalRecords
        })
        .catch((e) => {
          this.$emit('error', e)
        })
    },
    setAsDefaultSchema(schema) {
      let req = { name: schema.name }
      if (schema.isDefault === true) {
        req = {}
      }
      Core.setDefaultMetadataSchema(req)
        .then(() => {
          this.$refs.grid.reload()
        })
        .catch((e) => {
          this.$emit('error', e)
        })
    },
    deleteMetadataSchema(name) {
      this.$confirm({ text: `Are you sure you want do delete schema - ${name}?` })
        .then((conf) => {
          if (conf) {
            Core.deleteMetadataSchema(name)
              .then(() => {
                this.$refs.grid.reload()
              })
              .catch((e) => this.error(e))
          }
        })
    }
  },
  components: {
    DataGrid
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/core/configuration/metadataschema/MetadataSchemas.vue